import React from 'react';
import PropTypes from 'prop-types';
import AButton from '../atoms/_atoms.button';
import AButtonIndicator from '../atoms/_atoms.button-indicator';
import MCheckBox from './_molecules.checkbox';
import { PRODUCT_CONFIG } from '../../config/product.config';

export default function MProductDetailControls({
	title,
	webshop,
	className,
	documents,
	showCompare,
	isCompared,
	onCompare,
	onContact,
}) {
	const downloadDocument = (url) => {
		const a = window.document.createElement('a');
		a.href = url;
		a.setAttribute('target', '_blank');
		a.setAttribute('download', title);
		a.click();
	};

	let doc;
	let compare;

	const goToWebshop = () => {
		const a = window.document.createElement('a');
		a.href = webshop || PRODUCT_CONFIG.webshopUrl;
		a.setAttribute('target', '_blank');
		a.click();
	};

	if (documents && documents.length) {
		doc = (<div>
			{documents.map(item => (<AButtonIndicator
				value="PRODUCT_DETAIL.DOWNLOAD_DOCUMENTATION"
				intlValue={{ name: item.name }}
				icon="download"
				onClick={() => downloadDocument(item.url)}
			/>))}
		</div>);
	}

	if (showCompare) {
		compare = (
			<MCheckBox
				id="chxCompare"
				label="PRODUCT_DETAIL.COMPARE"
				onClick={onCompare}
				value={isCompared}
			/>
		);
	}

	return (
		<article className={`m-product-detail-controls ${className}`}>
			{compare}
			{doc}
			<div className="sub-controls">
				<AButton
					value="PRODUCT_DETAIL.ASK_OFFER"
					onClick={onContact}
				/>
				<AButton
					value="PRODUCT_DETAIL.GO_TO_WEBSHOP"
					onClick={goToWebshop}
				/>
			</div>
		</article>
	);
}

MProductDetailControls.propTypes = {
	title: PropTypes.string,
	className: PropTypes.string,
	documents: PropTypes.array,
	showCompare: PropTypes.bool,
	isCompared: PropTypes.bool,
	onCompare: PropTypes.func.isRequired,
	onContact: PropTypes.func.isRequired,
};

MProductDetailControls.defaultProps = {
	documents: [],
	title: '',
	className: '',
	showCompare: false,
	isCompared: false,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.product-detail-controls.js